<template lang="html">
  <section class="app-read-gallery" role="tablist">
    <b-card no-body class="mb-1" :key="idx" v-for="(gallery, idx) in galleries">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block href="" v-b-toggle="'accordion-'+idx" variant="light">{{gallery.title}}</b-button>
      </b-card-header>
      <b-collapse :id="'accordion-'+idx" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text class="d-flex">
            <img :src="encodeURI(getBaseURL + gallery.src)" :alt="gallery.name" class="img-fluid img-thumbnail w-25">
            <div class="d-flex flex-wrap justify-content-between">
              <div><strong>award_id : </strong>{{gallery.gallery_id}}</div>
              <div><strong>type : </strong>{{gallery.type}}</div>
              <div><strong>date_created : </strong>{{gallery.date_created}}</div>
              <div><strong>date_uploaded : </strong>{{gallery.date_uploaded}}</div>
              <div><strong>date_updated : </strong>{{gallery.date_updated}}</div>
              <div><strong>link : </strong>{{gallery.link}}</div>
              <div><strong>src : </strong>{{gallery.src}}</div>
              <div><strong>description : </strong>{{gallery.description}}</div>
              <div><strong>title : </strong>{{gallery.title}}</div>
            </div>
          </b-card-text>
          <b-card-text class="mt-4 text-center">
            <button type="button" class="btn btn-primary"
                    @click="navigateAway({id: gallery.gallery_id, title: gallery.title}, 'update')">
              Update
            </button>
            <button type="button" class="btn btn-danger ml-3"
                    @click="navigateAway({id: gallery.gallery_id, title: gallery.title}, 'delete')">
              Delete
            </button>
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>
  </section>
</template>

<script lang="js">
import {mapGetters, mapActions} from "vuex";
export default {
  name: 'ReadGallery',
  props: [],
  mounted () {},
  created () {
    this.readData()
      .then(data => this.galleries = data)
      .catch()
  },
  data () {
    return {
      galleries: null,
    }
  },
  methods: {
    ...mapActions([
      'setCurrentElement',
      'setOperation',
      'setCrudComponent',
      'setPreviousOperation',
      'readData'
    ]),
    navigateAway(object, tab) {
      this.setCurrentElement(object);
      this.setPreviousOperation(this.getOperation);
      this.setOperation(tab);
      this.setCrudComponent('app-' + tab + '-' + this.getComponent);
    }
  },
  computed: {
    ...mapGetters([
      'getCurrentElement',
      'getOperation',
      'getComponent',
      'getBaseURL'
    ])
  }
}
</script>

<style scoped lang="scss">
  .app-read-gallery {}
</style>



// WEBPACK FOOTER //
// src/components/galleries/ReadGallery.vue